// @flow
import * as React from 'react';
import { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import SearchView from 'containers/search';
import { ReviewFieldsets } from 'containers/search/SearchForm';
import { ClientContext } from 'containers/client/ClientProvider';
import { getIsPwrDistroClient } from 'components/ModerationCard/ClientModerationCard/utils';

const label = 'Native Reviews';
const ReviewSearch = (props: *) => {
  const clientProps = useContext(ClientContext);
  if (clientProps && getIsPwrDistroClient(clientProps.clientId, clientProps)) {
    const { location } = props;
    const newPathname = location.pathname.replace(
      '/native-reviews',
      '/reviews-search'
    );
    return <Redirect to={{ pathname: newPathname, search: location.search }} />;
  }

  return (
    <SearchView
      label={label}
      primaryFieldsets={ReviewFieldsets.primaryFieldsets}
      extraFieldsets={ReviewFieldsets.extraFieldsets}
      {...props}
    />
  );
};

ReviewSearch.label = label;

export default ReviewSearch;



// WEBPACK FOOTER //
// ./src/containers/search/NativeReviews.js